import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
var DialogOptionsContext = /*#__PURE__*/React.createContext({
  hideHeader: false,
  onDialogWillOpen: () => undefined,
  onDialogDidOpen: () => undefined,
  onDialogWillClose: () => undefined
});
DialogOptionsContext.displayName = 'DialogOptionsContext';
export var Consumer = DialogOptionsContext.Consumer;
export var Provider = DialogOptionsContext.Provider;
export var DialogOptionsProvider = props => {
  var {
      children
    } = props,
    providerProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Provider, {
    value: providerProps
  }, children);
};
export var withDialogOptions = Target => props => /*#__PURE__*/React.createElement(DialogOptionsContext.Consumer, null, value => /*#__PURE__*/React.createElement(Target, _extends({}, value, props)));
//# sourceMappingURL=index.js.map